import { SmService } from "supermappe-core";
import {
  BusyMessage,
  CredentialsMissingMessage,
  CredentialsResponseMessage,
  DirtyStateMessage,
  PlayResponseMessage,
  SaveStatusMessage,
  ShellMessage,
  UserLoggedOutMessage
} from "../../../../commondata/messages/messages-dto";

import { EventEmitter, inject, Injectable } from "@angular/core";
import { FirebaseAuthService } from "./firebase/firebase-auth.service";
import { MESSAGE } from "../../../../commondata/messages/msg-constants";
import { InitialStateDto } from "../../../../commondata/messages/initial-state-dto";
import { AuthenticationService, Credentials } from "./authentication/authentication.service";
import { Router } from "@angular/router";
import { ModuleStateService } from "../module-state.service";
import { User } from "firebase/auth";
import { TranslateService } from "@ngx-translate/core";
import { ThemeManagerService } from "../theme-manager.service";
import { CreateDocService } from "../shared/commands/create-doc.service";
import { PrintMapService } from "../shared/commands/print-map.service";
import { ZoomService } from "../shared/commands/zoom.service";
import { MapFindService } from "../shared/map-find/map-find.service";
import { ConvertToImageService } from "../shared/commands/convert-to-image.service";
import { CustomSelectElement } from "../shared/custom-select-element-dto";
import { Subscription } from "rxjs";
import { DELIMITERS } from "../../../../commondata/messages/delimiters";
import { QuickEditService } from "../shared/commands/quick-edit.service";
import { SelectionDataDto } from "../../../../commondata/messages/selection-data-dto";
import { ImageDataDto } from "../../../../commondata/messages/image-data-dto";
import { MatomoTracker } from "ngx-matomo-client";

@Injectable({
  providedIn: "root",
})
export class ModuleMessageService {
  private smService = inject(SmService);
  private firebaseAuthService = inject(FirebaseAuthService);
  private authenticationService = inject(AuthenticationService);
  private router = inject(Router);
  private moduleStateService = inject(ModuleStateService);
  private translateService = inject(TranslateService);
  private themeManagerService = inject(ThemeManagerService);
  private createDocService = inject(CreateDocService);
  private printService = inject(PrintMapService);
  private zoomService = inject(ZoomService);
  private mapFindService = inject(MapFindService);
  private convertToImageService = inject(ConvertToImageService);
  private quickEditService = inject(QuickEditService);
  private tracker = inject(MatomoTracker);

  private moduleId = "";
  private forceOpenView = false;
  private showMap = false;


  private shellCredentials: any;
  private shellfbCredentials: any;
  private shelltoken: any;
  public isAuthenticationChanged = new EventEmitter<Credentials>();
  public saveRequested = new EventEmitter();

  private onBusyStateChangeSubscription: Subscription | undefined;

  userInitialized = false;
  credentialmissing = false;

  constructor() { }

  public initialize(moduleId: string, forceOpenView: boolean, showMap: boolean, isNew: boolean, noUser: boolean, isLocked: boolean, startText: string) {
    this.moduleId = moduleId;
    this.forceOpenView = forceOpenView;
    this.showMap = showMap;

    this.moduleStateService.isLockedbyUser = isLocked;
    this.moduleStateService.isNew = isNew;
    if (isNew) {
      this.moduleStateService.name = this.translateService.instant('NEW_MAP');
    }
    if (!noUser) {
      this.moduleStateService.onDirtyStateChange.subscribe((status: boolean) => {
        const msg = new DirtyStateMessage(this.moduleStateService.docId, status);
        this.sendMessage(msg);
      });
      this.moduleStateService.onSaveStatusChange.subscribe((status: number) => {
        const msg = new SaveStatusMessage(this.moduleStateService.docId, status);
        this.sendMessage(msg);
      });
      this.onBusyStateChangeSubscription?.unsubscribe();
      this.onBusyStateChangeSubscription = this.moduleStateService.onBusyStateChange.subscribe((status: boolean) => {
        const msg = new BusyMessage(this.moduleStateService.docId, status);
        this.sendMessage(msg);
      });

    }
  }

  handleMessage(event: MessageEvent) {
    const eventData = event.data as unknown as ShellMessage;
    switch (eventData.msgType) {
      case MESSAGE.MSGTYPE.CREDENTIAL_RESPONSE:
        // Credenziali ricevute
        const msg = event.data as unknown as CredentialsResponseMessage;
        this.shellCredentials = msg.msgData.credentials;
        this.shellfbCredentials = msg.msgData.fbcredentials;
        this.shelltoken = msg.msgData.token;
        const cr = this.firebaseAuthService.getCurrentFirebaseUserEmail(); // this.firebaseAuthService.getFirebaseUser(); // this.authenticationService.credentials;
        const forcelogin = cr !== JSON.parse(this.shellCredentials).username; //this.shellCredentials;
        if (forcelogin) {
          this.authenticationService.setCredentials(
            JSON.parse(this.shellCredentials)
          );
        }
        this.reloadCredentials(forcelogin)
          .then((cred: any) => {
            this.authenticationService.reloadCredentials();
            localStorage.setItem("fbcredentials", this.shellfbCredentials);
            localStorage.setItem("token", this.shelltoken);
            if (cred?.displayName === "") {
              const msg = new CredentialsMissingMessage(
                this.moduleStateService.guid,
                { createCustomToken: true }
              );
              this.sendMessage(msg);
            } else {
              const url = (this.showMap ? 'map-show' : (this.forceOpenView ? 'map-view' : 'map-edit'));
              this.router.navigate([url], { replaceUrl: true });
            }
          })
          .catch((error) => {
            const msg = new CredentialsMissingMessage(this.moduleId, {
              createCustomToken: true,
            });
            (window as any).top.postMessage(msg, "*");
          });
        break;
      case MESSAGE.MSGTYPE.CREDENTIAL_CHANGED:
        const cred = eventData.msgData as Credentials;
        this.authenticationService.setCredentials(cred);
        this.isAuthenticationChanged.emit(cred);

        break;
      case MESSAGE.MSGTYPE.USER_LOGOUT:
        this.authenticationService.logout().subscribe(() => {
          const msglogout = new UserLoggedOutMessage(this.moduleId, {});
          this.sendMessage(msglogout); const url = (this.showMap ? 'map-show' : (this.forceOpenView ? 'map-view' : 'map-edit'));
          this.router.navigate([url], { replaceUrl: true });
        });
        break;
      case MESSAGE.MSGTYPE.NOTIFY_TARGET_DOC:
        // console.log('NOTIFY_TARGET_DOC: ' + JSON.stringify(eventData.msgData));
        this.moduleStateService.sideDocInfo = eventData.msgData;
        break;
      case MESSAGE.MSGTYPE.CHOOSEN_FILE_DRIVE:
        const result = JSON.stringify({ fileId: eventData.msgData.googleId, filename: eventData.msgData.filename });
        this.moduleStateService.onChooseFileDrive.emit(result);
        break;
      case MESSAGE.MSGTYPE.DOC_NAME_RESPONSE:
        this.moduleStateService.name = eventData.msgData.docName;
        break;
      case MESSAGE.MSGTYPE.MATH_CONTENT:
        this.moduleStateService.onMathContent.emit(eventData);

        //MATOMO Math insert formula in Map 
        try {
          console.log('MATOMO event Math insert formula in Map');
          this.tracker.trackEvent('Math', 'Insert formula in Map', 'InsertFormulaInMap');
        } catch (e: any) {
          console.error('matomo error ' + e.message);
        }
        break;
      case MESSAGE.MSGTYPE.MATH_OPEN:
        this.moduleStateService.onMathOpen.emit(eventData.msgData);
        break;
      case MESSAGE.MSGTYPE.SAVE_DOC_REQUEST:
        if (this.moduleStateService.docId === eventData.msgData.docId) {
          this.saveRequested.emit();
        }
        break;
      case MESSAGE.MSGTYPE.MAP_DOC_FILE_CREATED:
        this.moduleStateService.docFileId = eventData.msgData.docFileId;
        this.createDocService.onDocFileIdChange.emit(eventData.msgData.docFileId);
        break;
      case MESSAGE.MSGTYPE.ENABLE_TTS:
        this.moduleStateService.ttsEnabled = eventData.msgData.ttsEnable;

        //MATOMO Map enable TTS
        if (this.moduleStateService.ttsEnabled) {
          try {
            console.log('MATOMO event Map enable TTS');
            this.tracker.trackEvent('Map', 'Enable TTS', 'EnableTTS');
          } catch (e: any) {
            console.error('matomo error ' + e.message);
          }
        }
        break;
      case MESSAGE.MSGTYPE.PRINT:
        this.printService.printMap(this.moduleStateService.limitPrintSize, this.printService.useQRcodes);
        break;
      case MESSAGE.MSGTYPE.CENTER_MAP:
        this.zoomService.centerMap();
        break;
      case MESSAGE.MSGTYPE.ZOOM:
        if (eventData.msgData.zoom === 100) {
          this.zoomService.centerMap();
        } else {
          this.zoomService.zoom(eventData.msgData.zoom);
        }
        break;
      case MESSAGE.MSGTYPE.FIND_IN_DOC:
        this.mapFindService.toggleFindText();
        break;
      case MESSAGE.MSGTYPE.CONVERT_TO_IMAGE:
        const qrCodes = eventData.msgData.qrCode;
        this.convertToImageService.convert(true, qrCodes, this.moduleStateService.docId, this.moduleStateService.docFileId);
        break;
      case MESSAGE.MSGTYPE.SET_INITIAL_STATE:
        const state = (eventData.msgData.state as InitialStateDto);
        this.moduleStateService.guiLanguage = state.guiLanguage
        this.themeManagerService.toggleTheme(eventData.msgData.state.theme);
        this.moduleStateService.ttsEnabled = state.enableTTS;
        this.moduleStateService.languages = this.convertLanguagesObjectToArray(state.languages);
        this.moduleStateService.voices = { ...state.voices };
        this.moduleStateService.onSetInitialState.emit(state);
        break;
      case MESSAGE.MSGTYPE.TALKING_START:
        this.moduleStateService.onTalkingStart.emit();
        break;
      case MESSAGE.MSGTYPE.TALKING_END:
        this.moduleStateService.onTalkingEnd.emit();
        break;
      case MESSAGE.MSGTYPE.PLAY:
        const readable = this.getReadableTextFromSelection();
        this.sendMessage(new PlayResponseMessage(this.moduleStateService.guid, readable.caller, readable.text, readable.language));
        break;
      case MESSAGE.MSGTYPE.LANGUAGE_CHANGED:
        this.moduleStateService.onLanguageChangedFromShell.emit(eventData.msgData.language);
        break;
      case MESSAGE.MSGTYPE.SEARCH_SELECTION:
        this.moduleStateService.onSearchSelection.emit(eventData.msgData);
        break;
      case MESSAGE.MSGTYPE.SPEECH_RECOGNITION_TO_MAP:
        const isEnabled = eventData.msgData?.isEnabled || false;
        this.quickEditService.setSpeechEdit(this.quickEditService.ORIGIN.MAP, isEnabled);
        break;
      case MESSAGE.MSGTYPE.COPY_SELECTION:
        this.moduleStateService.onCopySideSelection.emit();
        break;
      case MESSAGE.MSGTYPE.PASTE_SELECTION:
        const data: SelectionDataDto = eventData.msgData as SelectionDataDto;
        data.fromGuid = eventData.fromGuid;
        this.moduleStateService.onPasteSideSelection.emit(data);
        break;
      case MESSAGE.MSGTYPE.IMAGE_INSERT:
        const imageData: ImageDataDto = eventData.msgData as ImageDataDto;
        this.moduleStateService.onImageInsert.emit(imageData);
        break;
      case MESSAGE.MSGTYPE.IMAGE_MAP_INSERT:
        const image: string = eventData.msgData;
        this.moduleStateService.onImageMapInsert.emit(image);
        break;
      case MESSAGE.MSGTYPE.REQUEST_CROP_IMAGE:
        this.moduleStateService.onRequestCrop.emit();
        break;
      case MESSAGE.MSGTYPE.BEFORE_EXIT:
        this.moduleStateService.onBeforeExit.emit();
        break;
      case MESSAGE.MSGTYPE.DOC_PICKER_RESPONSE:
        this.moduleStateService.onAttachDocument.emit(eventData.msgData);
        break;
      case MESSAGE.MSGTYPE.ATTACH_NEW_DOC:
        this.moduleStateService.onAttachNewDocument.emit(eventData.msgData);
        break;
      case MESSAGE.MSGTYPE.IMAGE_MAP_REQUEST:
        this.moduleStateService.onImageMapRequest.emit();
        break;
      case MESSAGE.MSGTYPE.MAP_FRAGMENT_COPIED:
        if (eventData && eventData.fromGuid && eventData.fromGuid !== this.moduleStateService.guid) {
          this.moduleStateService.onMapFragmentCopied.emit(eventData.msgData);
        }
        break;
    }
  }

  getReadableTextFromSelection(): any {
    const result = { caller: 'map', text: '', language: '' };
    const node = this.smService.getSelectedNode();
    if (node) {
      result.text = node.titleText + (node.titleText ? '. ' : '');
      if (node.links && node.links.length > 0) {
        for (let i = 0; i < node.links.length; i++) {
          const link = node.links[i];
          if (link.type === 'ltx' && link.uri && !link.uri.startsWith(DELIMITERS.LATEX_START)) {
            result.text += '\n' + DELIMITERS.LATEX_START + link.uri + DELIMITERS.LATEX_END;
          }
          else if (link.uri) {
            result.text += '\n' + link.uri;
          }
        }
      }
      result.language = node.nodeData?.language || '';
    } else {
      const edge = this.smService.getSelectedEdge();
      if (edge) {
        result.text = edge.titleText;
        result.language = edge.edgeData?.language || '';
      }
    }
    return result;
  }

  convertLanguagesObjectToArray(languages: any): CustomSelectElement[] {
    const result: CustomSelectElement[] = [];
    const keys = Object.keys(languages);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const language = languages[key];
      result.push(
        {
          viewValue: language.viewValue,
          value: language.value,
          icon: language.icon,
          hidden: language.hidden,
          browserTTS: language.browserTTS
        }
      );
    }
    return result;
  }

  reloadCredentials(forcelogin: boolean): Promise<User | null> {
    // Ricarica credenziali
    return new Promise((resolve, reject) => {
      // const credentials = localStorage.getItem("credentials");
      const user = this.firebaseAuthService.currentUser;
      Promise.resolve()
        .then(() => {
          if (forcelogin && this.firebaseAuthService.currentUser !== null) {
            return this.firebaseAuthService.logoutPromise();
          } else {
            return Promise.resolve();
          }
        })
        .then(() => {
          const user = this.firebaseAuthService.currentUser;
          if (forcelogin || this.firebaseAuthService.currentUser === null) {
            const customToken =
              this.authenticationService?.credentials?.customToken || "";
            if (customToken) {
              return this.firebaseAuthService.signInCustomToken(customToken);
            } else {
              return this.firebaseAuthService.getCurrentFirebaseUser();
            }
          } else {
            return this.firebaseAuthService.getCurrentFirebaseUser();
          }
        })
        .then((cred: User | null) => {
          this.userInitialized = true;
          return resolve(cred);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  }

  public sendMessage(message: any) {
    (window as any).top.postMessage(message, "*");
  }
}
